<template>
  <el-card shadow="never" class="aui-card--fill">
    <div class="mod-sys__slcustomer}">
      <el-form
        :inline="true"
        :model="dataForm"
        @keyup.enter.native="getDataList()"
      >
        <el-form-item>
          <el-input
            v-model="dataForm.applyNo"
            placeholder="渠道订单号"
            clearable
          ></el-input>
        </el-form-item>

        <el-form-item>
          <el-input
            v-model="dataForm.id"
            placeholder="进件ID"
            clearable
          ></el-input>
        </el-form-item>

        <el-form-item>
          <el-date-picker
            v-model="dateValue"
            type="daterange"
            :picker-options="pickerOptions"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            @change="getTimes"
            value-format="yyyy-MM-dd"
            align="right"
          >
          </el-date-picker>
        </el-form-item>

        <el-form-item>
          <el-select
            v-model="dataForm.status"
            filterable
            clearable
            placeholder="进件状态"
          >
            <el-option
              v-for="(item, index) in statusList2"
              :key="index"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </el-form-item>

        <el-form-item>
          <el-select
            v-model="dataForm.flowStep"
            @change="getSecondDropdownData"
            filterable
            clearable
            placeholder="客户流程节点"
          >
            <el-option
              v-for="(item, index) in flowStatus"
              :key="index"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <!-- <button @click="cha()">查看</button> -->
        <el-form-item>
          <el-select
            v-model="dataForm.flowStepName"
            filterable
            clearable
            placeholder="客户流程状态"
          >
            <el-option
              v-for="(item, index) in secondDropdownOptions"
              :key="index"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </el-form-item>

        <el-form-item>
          <el-button @click="getDataList()">{{ $t("query") }}</el-button>
        </el-form-item>
      </el-form>
      <el-table
        v-loading="dataListLoading"
        :data="dataList"
        border
        style="width: 100%"
      >
        <!-- <el-table-column type="selection" header-align="center" align="center" width="50"></el-table-column> -->
        <el-table-column
          prop="id"
          label="进件ID/申请ID"
          header-align="center"
          align="center"
        ></el-table-column>
        <el-table-column
          prop="applyNo"
          label="渠道订单号/FI申请编号"
          header-align="center"
          align="center"
        >
          <!-- <template slot-scope="scope">
                        <el-select v-if="scope.row.myishsow" v-model="scope.row.brokerType"  filterable clearable  placeholder="类型">
                    <el-option
                            v-for="(item,index) in userTypes"
                            :key="index"
                            :label="item.label"
                            :value="item.value">
                    </el-option>
              </el-select>
              <div v-else>{{ geteducation(scope.row.brokerType,'userType') }}</div>
                        {{ geteducation(scope.row.brokerType, "userType") }} 
                    </template> -->
        </el-table-column>
        <el-table-column
          prop="createDate"
          label="进件时间"
          header-align="center"
          align="center"
        ></el-table-column>
        <el-table-column
          prop="borrowerInformation"
          width="230"
          label="借款人信息"
          header-align="center"
          align="center"
        >
          <template slot-scope="scope">
            <span v-html="getText(scope.row.borrowerInformation)"></span>
          </template>
        </el-table-column>
        <el-table-column
          prop="status"
          label="进件状态"
          header-align="center"
          align="center"
        >
          <!-- <el-table-column prop="status" min-width="200" label="进件状态" header-align="center" align="center"> -->
          <template slot-scope="scope">
            <el-select
              v-if="
                scope.row.myishsow &&
                  scope.row.status != '-1' &&
                  scope.row.status != '7' &&
                  scope.row.status != '6'
              "
              v-model="scope.row.status"
              filterable
              clearable
              placeholder="类型"
            >
              <el-option
                v-for="(item, index) in statusList"
                :key="index"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
            <div v-else>{{ geteducation(scope.row.status, "status") }}</div>
          </template>
        </el-table-column>
        <el-table-column
          prop="updateTime"
          label="更新日期"
          header-align="center"
          align="center"
        ></el-table-column>
        <el-table-column
          prop="realAmount"
          label="核额金额"
          header-align="center"
          align="center"
        ></el-table-column>
        <el-table-column
          prop="institutionParam.withDrawDate"
          label="提款时间"
          header-align="center"
          align="center"
        ></el-table-column>
        <el-table-column
          prop="loanAmount"
          label="生效金额"
          header-align="center"
          align="center"
        ></el-table-column>
        <el-table-column
          prop="institutionParam.borrowingRate"
          label="借款利率"
          header-align="center"
          align="center"
        ></el-table-column>
        <el-table-column
          prop="institutionParam.loanTerm"
          label="借款期限"
          header-align="center"
          align="center"
        ></el-table-column>
        <el-table-column
          prop="flowStep"
          label="客户流程节点"
          header-align="center"
          align="center"
        >
          <template slot-scope="scope">
            {{ flowStepWordText(scope.row.flowStep) }}
          </template>
        </el-table-column>
        <el-table-column
          prop="flowStepStatus"
          label="客户流程状态"
          header-align="center"
          align="center"
        >
          <template slot-scope="scope">
            {{ flowStepStatusWordText(scope.row.flowStepStatus) }}
          </template>
        </el-table-column>
        <el-table-column
          prop="createDate"
          label="还款计划"
          header-align="center"
          align="center"
        >
          <template slot-scope="scope">
            <el-button
              type="text"
              size="small"
              class="xiang"
              @click="JumpDetails(scope.row)"
              >详情</el-button
            >
          </template>
        </el-table-column>
        <el-table-column
          prop="remark"
          label="备注"
          header-align="center"
          align="center"
        ></el-table-column>
        <el-table-column
          :label="$t('handle')"
          fixed="right"
          header-align="center"
          align="center"
          width="150"
        >
          <template slot-scope="scope">
            <!-- <el-button  type="text" size="small" class="xiang"
                  @click="submitStatus(scope.row)">查询</el-button> -->
            <el-button
              type="text"
              size="small"
              class="xiang"
              @click="yongyingQuery(scope.row)"
              >查询</el-button
            >
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        :current-page="page"
        :page-sizes="[10, 20, 50, 100]"
        :page-size="limit"
        :total="total"
        layout="total, sizes, prev, pager, next, jumper"
        @size-change="pageSizeChangeHandle"
        @current-change="pageCurrentChangeHandle"
      >
      </el-pagination>
    </div>
    <el-dialog
      :visible.sync="dialogVisible"
      width="75%"
      :before-close="handleClose"
    >
      <component
        :is="dynamicComponent"
        :row="dialogParam"
        :close-data="closeData"
        ref=""
      ></component>
    </el-dialog>
  </el-card>
</template>
<style scoped>
.xiang {
  color: rgb(30, 152, 215);
}
</style>
<script>
import mixinViewModule from "@/mixins/view-module";
import Repayment from "./repayment.vue";
import { getList, pageList } from "@/api/list";
import { throws } from "assert";
// import AddOrUpdate from './entry-add-or-update'
export default {
  mixins: [mixinViewModule],
  data() {
    return {
      closeData: {},
      mixinViewModuleOptions: {
        getDataListURL: "/sys/inputmanagement/page",
        getDataListIsPage: true,
        // exportURL: "/sys/slproducttender/export",
        exportURL: "/sys/inputmanagement/export",
        deleteURL: "/sys/slproducttender",
        deleteIsBatch: true,
      },
      text: "修改",
      flowStatus: [],
      statusList: [],
      statusList2: [],
      secondDropdownOptions: [],
      mechanismNames: [],
      productNameList: [],
      dataForm: {
        status: "",
        // flowStep:"",
        id: "",
        userType: "",
        productCode: "1658667732359069697",
        startDate: "",
        endDate: "",
        flowStep: "", // 第一个下拉框的值
        flowStepName: "", // 第二个下拉框的值
      },
      dateValue: "",
      pickerOptions: {
        shortcuts: [
          {
            text: "今天",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              picker.$emit("pick", [start, end]);
            },
          },

          {
            text: "昨天",
            onClick(picker) {
              console.log(picker);
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24);
              end.setTime(end.getTime() - 3600 * 1000 * 24);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "过去七天",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "上周",
            onClick(picker) {
              // 上周开始时间
              const starta = new Date();
              var first = starta.getDate() - starta.getDay() - 6;
              var startDate = new Date(starta.setDate(first));
              const start = new Date(startDate);
              start.setHours(0, 0, 0, 0);
              //  上周结束时间
              var currentDate = new Date();
              var firsts = currentDate.getDate() - currentDate.getDay() - 6;
              var last = firsts + 6;
              var endDate = new Date(currentDate.setDate(last));
              const end = new Date(endDate);
              end.setHours(23, 59, 59, 0);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "本周",
            onClick(picker) {
              var end = new Date();
              var week = end.getDay();
              console.log(week, "week");
              //一天的毫秒数
              var millisecond = 1000 * 60 * 60 * 24;
              //减去的天数
              var minusDay = week != 0 ? week - 1 : 6;

              //本周 周一
              var monday = new Date(end.getTime() - minusDay * millisecond);
              const start = new Date(monday);
              start.setHours(0, 0, 0, 0);
              console.log("2312", start, end);
              picker.$emit("pick", [start, end]);
            },
          },
        ],
      },
      dialogVisible: false,
      dynamicComponent: null,
      dialogParam: null,
      flowStepNamesList: [],
    };
  },
  computed: {
    // flowStepStatusWordText 转换
    flowStepStatusWordText() {
      return (val) => {
        let text = val;
        let obj = this.flowStepNamesList.find((item) => item.dictValue === val);
        if (obj && obj.dictLabel) {
          text = obj.dictLabel;
        } else {
          text = val;
        }
        return text;
      };
    },
  },
  created() {
    this.getflowStatusOptions();
    this.getentryStatusOptions();
    getList("/sys/inputmanagement/mechanism").then(({ data: res }) => {
      // console.log(res.data);
      this.mechanismNames = res.data.map((item) => {
        return { value: item.name, label: item.name };
      });
      // this.mechanismNames
    });
    pageList("/sys/inputmanagement/slproduct").then(({ data: res }) => {
      // console.log(res.data.list);
      this.productNameList = res.data.list.map((item) => {
        return { value: item.id, label: item.productName };
      });
      // this.mechanismNames
    });
  },

  methods: {
    // 查询了
    yongyingQuery(row) {
      console.log(row);
      if (row.applyNo) {
        this.$http
          .get("/yongying/query", {
            params: {
              chnOrderId: row.applyNo,
            },
          })
          .then((res) => {
            console.log(res);
            if(res.data.code != 0){
                this.$message.error(res.data.msg);
            }else{
                this.$message.success('查询成功：' + res.data.data.commonInfoDTO.contractNo);
            }
          });
      } else {
        return this.$message.error("没有渠道订单号/FI申请编号");
      }
    },
    // flowStep转换
    flowStepWordText(val) {
      let text = "";
      let obj = this.flowStatus.find((item) => item.value === val);
      if (obj && obj.label) {
        text = obj.label;
      } else {
        text = val;
      }
      return text;
    },

    handleClose(done) {
      this.closeData = { message: true };
      done();
      this.dynamicComponent = "";
    },
    getTimes() {
      if (this.dateValue != null) {
        this.dataForm.startDate = this.dateValue[0] + " 00：00：00";
        this.dataForm.endDate = this.dateValue[1] + " 23：59：59";
      } else {
        this.dataForm.startDate = "";
        this.dataForm.endDate = "";
      }
    },
    ///sys/mechanism/list
    getText(v) {
      // console.log(v);
    
      if (JSON.parse(v)["企业名称"] && JSON.parse(v)["营业执照号"]) {
        return `姓名: ${JSON.parse(v)["姓名"]}<br/>手机号: ${
          JSON.parse(v)["手机号"]
        }<br/>身份证号: ${JSON.parse(v)["身份证号"] ||
          JSON.parse(v)["身份证"]}<br/>企业名称: ${
          JSON.parse(v)["企业名称"]
        }<br/>营业执照号: ${JSON.parse(v)["营业执照号"]}`;
      }else if(JSON.parse(v)["营业执照号"]){
        return `姓名: ${JSON.parse(v)["姓名"]}<br/>手机号: ${
          JSON.parse(v)["手机号"]
        }<br/>身份证号: ${JSON.parse(v)["身份证号"] ||
          JSON.parse(v)["身份证"]}<br/>企业名称: 
          <br/>营业执照号: ${JSON.parse(v)["营业执照号"]}`;
      }else if(JSON.parse(v)["企业名称"]){
        return `姓名: ${JSON.parse(v)["姓名"]}<br/>手机号: ${
          JSON.parse(v)["手机号"]
        }<br/>身份证号: ${JSON.parse(v)["身份证号"] ||
          JSON.parse(v)["身份证"]}<br/>企业名称: ${
          JSON.parse(v)["企业名称"]
        }<br/>营业执照号: `;
      }else{
        return `姓名: ${JSON.parse(v)["姓名"]}<br/>手机号: ${
          JSON.parse(v)["手机号"]
        }<br/>身份证号: ${JSON.parse(v)["身份证号"] ||
          JSON.parse(v)["身份证"]}<br/>企业名称:
        <br/>营业执照号: `;
      }
    },
    ifTrue(row) {
      if (row.applyNo) {
        return false;
      } else {
        if (row.status != "-1" && row.status != "7") {
          return true;
        }
        return false;
      }
    },

    cha() {
      //   console.log(dataForm.flowStep);
    },
    //修改状态
    submitStatus(row, num) {
      // console.log(this.dataList.findIndex((item) => item.id == row.id));
      let n = this.dataList.findIndex((item) => item.id == row.id);
      this.$set(this.dataList, n, {
        ...this.dataList[n],
        myishsow: !this.dataList[n].myishsow,
      });
      if (row.myishsow) {
        let obj = {
          id: row.id,
          remark: row.remark,
          status: row.status,
          realAmount: row.realAmount,
          loanAmount: row.loanAmount,
        };
        if (num) {
          this.$http
            .put(`sys/slproducttender/${row.id}?failureReason=${row.remark}`)
            .then(({ data: res }) => {
              if (res.code !== 0) {
                this.query();
                return this.$message.error(res.msg);
              }
              this.$message.success(res.msg);
              this.query();
            });
          return;
        }
        this.$http.put("/sys/slproducttender", obj).then(({ data: res }) => {
          if (res.code !== 0) {
            this.query();
            return this.$message.error(res.msg);
          }
          this.$message.success(res.msg);
          this.query();
        });
      }
    },
    geteducation(v, name) {
      // console.log(v);
      if (name == "userType")
        return this.userTypes.filter((item) => item.value == v)[0]?.label;
      // if(name == 'education') return this.educations.filter(item => item.value == v)[0]?.label ;
      // if(name == 'vipLevelId') return this.vipLevels.filter(item => item.value == v)[0]?.label ;
      // if(name == 'maritalStatus') return this.maritalStatus.filter(item => item.value == v)[0]?.label ;
      // if(name == 'isAuth') return this.isAuth.filter(item => item.value == v)[0]?.label ;
      // if(v == '-1'){
      //   return '审核未通过'
      // }
      // if(v == '7'){
      //   return '失效'
      // }
      // if(v == '6'){
      //   return '未在本机构完成申请'
      // }
      if (name == "status")
        return this.statusList2.filter((item) => item.value == v)[0]?.label;
    },
    //初始用户类型名称下拉框中的选项
    async getflowStatusOptions() {
      this.$http
        .get(`/sys/dict/data/list?dataType=flowStep`)
        .then(({ data: res }) => {
          console.log(res, "111");
          if (res.code !== 0) {
            return this.$message.error(res.msg);
          }
          this.flowStatus = [];
          if (res.data != null) {
            res.data.forEach((element) => {
              this.flowStatus.push({
                label: element.dictLabel,
                value: element.dictValue,
              });
            });

            if (this.flowStatus.length > 0) {
              this.flowStatus.map((item) => {
                this.$http
                  .get(`/sys/dict/data/list?dataType=${item.value}`)
                  .then((res) => {
                    // console.log(res.data)

                    this.flowStepNamesList = this.flowStepNamesList.concat(
                      res.data.data
                    );
                    console.log(this.flowStepNamesList);
                  });
              });
            }
          }
        })
        .catch(() => {});
    },
    async getSecondDropdownData() {
      // 根据第一个下拉框的值发起请求获取第二个下拉框的选项数据
      const selectedValue = this.dataForm.flowStep;
      console.log(this.dataForm.flowStep);
      // 发起请求，根据selectedValue获取第二个下拉框的选项数据
      this.$http
        .get(`/sys/dict/data/list?dataType=${selectedValue}`)
        .then(({ data: res }) => {
          console.log(res, "222");
          if (res.code !== 0) {
            return this.$message.error(res.msg);
          }
          this.secondDropdownOptions = res.data.map((element) => ({
            label: element.dictLabel,
            value: element.dictValue,
          }));
          this.dataForm.flowStepName = ""; // 清空第二个下拉框的值
        })
        .catch(() => {});
    },
    //初始进件状态下拉框中的选项
    async getentryStatusOptions() {
      this.$http
        .get(`/sys/dict/data/list?dataType=entryStatus`)
        .then(({ data: res }) => {
          if (res.code !== 0) {
            return this.$message.error(res.msg);
          }
          this.statusList = [];
          this.statusList2 = [];
          if (res.data != null) {
            res.data.forEach((element) => {
              this.statusList.push({
                label: element.dictLabel,
                value: element.dictValue,
              });
              this.statusList2.push({
                label: element.dictLabel,
                value: element.dictValue,
              });
            });
            // {label: '未在本机构完成申请', value: '6'}
            // this.statusList2.push(
            //     { label: "审核未通过", value: "-1" },
            //     { label: "失效", value: "7" }
            // );
          }
        })
        .catch(() => {});
    },
    // JumpDetails(applyNo,id,borrowerInformation,createDate,status){
    JumpDetails(row) {
      console.log(row);
      // this.$router.push({ path: '/repayment' , query:{id : e}});
      this.dynamicComponent = Repayment;
      this.dialogParam = row;
      this.dialogVisible = true;
    },
  },
  components: {
    // AddOrUpdate
  },
};
</script>
